import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function AdminSidebar() {

    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();           // hapus token & reset user
        navigate("/login"); // redirect ke login
    };

    return (
        <aside className="sidebar">
            <button type="button" className="sidebar-close-btn text-gray-500 hover-text-white hover-bg-main-600 text-md w-24 h-24 border border-gray-100 hover-border-main-600 d-xl-none d-flex flex-center rounded-circle position-absolute"><i className="ph ph-x"></i></button>

            <a href="index.html" className="sidebar__logo text-center p-20 position-sticky inset-block-start-0 bg-white w-100 z-1 pb-10">
                {/* <img src="" alt="Logo" /> */}
                <h2 className="text-main-600">Memoliworks</h2>
            </a>

            <div className="sidebar-menu-wrapper overflow-y-auto scroll-sm">
                <div className="p-20 pt-10">
                    <ul className="sidebar-menu">
                        <li className="sidebar-menu__item">
                            <a href="/admin/dashboard" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-gauge"></i></span>
                                <span className="text">Dashboard</span>
                            </a>

                        </li>

                        <li className="sidebar-menu__item">
                            <span className="text-gray-300 text-sm px-20 pt-20 fw-semibold border-top border-gray-100 d-block text-uppercase">Transaksi</span>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/orders" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-shopping-cart"></i></span>
                                <span className="text">Pesanan</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <span className="text-gray-300 text-sm px-20 pt-20 fw-semibold border-top border-gray-100 d-block text-uppercase">Laporan</span>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/report-sales" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-chart-line-up"></i></span>
                                <span className="text">Penjualan</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/report-sales-by-customer" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-users"></i></span>
                                <span className="text">By Customer</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/report-sales-by-product" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-package"></i></span>
                                <span className="text">By Product</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <span className="text-gray-300 text-sm px-20 pt-20 fw-semibold border-top border-gray-100 d-block text-uppercase">Master</span>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/categories" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-list-dashes"></i></span>
                                <span className="text">Category</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/sizes" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-ruler"></i></span>
                                <span className="text">Size</span>
                            </a>
                        </li>


                        <li className="sidebar-menu__item">
                            <a href="/admin/cover-fabrics" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-t-shirt"></i></span>
                                <span className="text">Cover Fabric</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/cover-designs" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-paint-brush"></i></span>
                                <span className="text">Cover Design</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/products" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-package"></i></span>
                                <span className="text">Product</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/bank-accounts" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-wallet"></i></span >
                                <span className="text">Bank Account</span>
                            </a>
                        </li>

                        

                        <li className="sidebar-menu__item">
                            <span className="text-gray-300 text-sm px-20 pt-20 fw-semibold border-top border-gray-100 d-block text-uppercase">Website</span>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/settings" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-browser"></i></span >
                                <span className="text">Web Idenity</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/banners" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-image"></i></span >
                                <span className="text">Banner</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/about-us" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-info"></i></span >
                                <span className="text">About Us</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="/admin/faqs" className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-question"></i></span >
                                <span className="text">FaQ</span>
                            </a>
                        </li>

                        <li className="sidebar-menu__item">
                            <a href="#" onClick={handleLogout} className="sidebar-menu__link">
                                <span className="icon"><i className="ph ph-sign-out"></i></span >
                                <span className="text">Logout</span>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
        </aside>
    );
}
